import { useContext, useRef } from 'react';
import { useInView } from 'react-intersection-observer';

import { MediaQueryContext } from '../../../../contexts/mediaQueryContext';

const useHomeFullBleed = (sources) => {
  const initialPlayerState = useRef({
    playing: true,
    muted: true,
  });
  const { ref, inView } = useInView({
    fallbackInView: true,
    threshold: 0,
    triggerOnce: true,
  });

  // TODO: portrait video doesnt respect object fit cover :(
  const { isDesktop } = useContext(MediaQueryContext);
  const playerSources = sources?.[isDesktop ? 'desktop' : 'mobile'];
  // const playerSources = sources?.desktop;

  return {
    ref,
    inView,
    initialPlayerState: initialPlayerState.current,
    playerSources,
  };
};

export default useHomeFullBleed;
